import React from "react";
import classNames from "classnames";
import {useRootStore, useUserState} from "@stores/AppStateContext";

import {formatDate} from "../../../utils/date";
import {UserAvatar} from "../Avatar/Avatar";

interface InfoBlockProps {
    userId: string;
    dateIso: string;
}

export const InfoBlockRow = ({userId, dateIso}: InfoBlockProps) => {
    const rootStore = useRootStore();
    const userState = useUserState();
    const userInfo = userState!.usersDS.users.get(userId);
    const dateObj = new Date(dateIso);
    const formatted = formatDate(rootStore.currentLocale, dateObj);
    return (
        <div className="DocumentInfo__name-block">
            {
                userInfo
                    ? <UserAvatar
                        size={24}
                        user={userInfo}
                        sx={{fontSize: '8px', textTransform: 'uppercase'}}
                    />
                    : null
            }
            <div className='DocumentInfo__name body-medium'>{userInfo ? userInfo.email : userId}</div>
            <div className={classNames({
                'DocumentInfo__date body-small': true,
                'DocumentInfo__date--today': formatted.isToday,
            })}>
                {formatted.date}
            </div>
        </div>
    )
}

